export enum AffiliateSourceId {
  INCOME_ACCESS = 1,
  ADJUST = 2,
}

export enum AffiliateSourceLabel {
  INCOME_ACCESS = 'IncomeAccess',
  ADJUST = 'Adjust',
}
